
<template>
    <div>
        <van-nav-bar
                title="Contacto"
                left-text=""
                right-text=""
                left-arrow
                @click-left="onClickLeft"
                @click-right="onClickRight"
        >
            <template #left>
                <van-icon name="arrow-left" color="#000000" />
                <span>Volver</span>
            </template>
        </van-nav-bar>
        <div id="applybank">
            <div class="apply_wrap">
                <div class="apply_banner">
                    <!--<img src="../../assets/img/applyhead.png" />-->
                </div>
                <div class="apply_head">
                    <div class="apply_hview">
                        <img src="../../assets/img/applyhead03.webp" />
                    </div>
                </div>

                <div class="apply_topview" style="height: auto; margin-bottom: 16px;">
                    <div class="apply_top" style="height: auto; padding: 10px;">
                        No nos comunicaremos con su contacto que proporciona a menos que su préstamo esté vencido.
                        Los siguientes ítems con * son obligatorios
                    </div>
                </div>
                <div class="apply_formview">
                    <div class="bank_conttop">
                        <div class="applyFormtitle">
                            <span>*</span> Contacto 1
                        </div>
                        <div class="bank_ctitems" @click="onCheckitem('one')">
                            <div class="bank_ctitem" :class="isCheck == 'one' ? 'bank_ctitem_active' : ''">
                                <div class="bank_ctileft">
                                    <template v-if="bankoneval == null">
                                        Elija el parentesco del contacto
                                    </template>
                                    <template v-else>
                                        {{bankoneval.name}}
                                    </template>
                                </div>
                                <div class="bank_ctiright">
                                    <div class="bank_ctirview"><img src="../../assets/img/comf_rparrow.png" alt=""></div>
                                </div>
                            </div>
                        </div>

                        <div class="bank_ctitems" @click="onCheckitem('one_name')">
                            <div class="bank_ctitem" :class="isCheck == 'one_name' ? 'bank_ctitem_active' : ''">
                                <div class="bank_ctileft" style="height: auto; padding-left: 0;">
                                    <van-field
                                            v-model="contacts_no1_name"
                                            label=""
                                            type="text"
                                            placeholder="Elija el contacto"
                                            :clearable="isTrue"
                                            :maxlength="maxLen"
                                    />
                                </div>
                                <div class="bank_ctiright" style="height: 0.555556rem; padding-right: 0.277778rem;">
                                    <div class="bank_ctirview" style="width: 0.555556rem; height: 0.555556rem;"><img style="display:block; width: 0.555556rem; height: 0.555556rem;" src="../../assets/img/tongxunlu.webp" alt=""></div>
                                </div>
                            </div>
                        </div>

                        <div class="bank_ctitems" @click="onCheckitem('one_mobile')">
                            <div class="bank_ctitem" :class="isCheck == 'one_mobile' ? 'bank_ctitem_active' : ''">
                                <van-field
                                        v-model="contacts_no1"
                                        label=""
                                        type="number"
                                        placeholder="Modificar el nombre del contacto"
                                        :clearable="isTrue"
                                        :maxlength="maxLenno"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="bank_conttop">
                        <div class="applyFormtitle">
                            <span>*</span> Contacto 2
                        </div>
                        <div class="bank_ctitems" @click="onCheckitem('two')">
                            <div class="bank_ctitem" :class="isCheck == 'two' ? 'bank_ctitem_active' : ''">
                                <div class="bank_ctileft">
                                    <template v-if="banktwoval == null">
                                        Elija el parentesco del contacto
                                    </template>
                                    <template v-else>
                                        {{banktwoval.name}}
                                    </template>
                                </div>
                                <div class="bank_ctiright">
                                    <div class="bank_ctirview"><img src="../../assets/img/comf_rparrow.png" alt=""></div>
                                </div>
                            </div>
                        </div>


                        <div class="bank_ctitems" @click="onCheckitem('two_name')">
                            <div class="bank_ctitem" :class="isCheck == 'two_name' ? 'bank_ctitem_active' : ''">
                                <div class="bank_ctileft" style="height: auto; padding-left: 0;">
                                    <van-field
                                            v-model="contacts_no2_name"
                                            label=""
                                            type="text"
                                            placeholder="Elija el contacto"
                                            :clearable="isTrue"
                                            :maxlength="maxLen"
                                    />
                                </div>
                                <div class="bank_ctiright" style="height: 0.555556rem; padding-right: 0.277778rem;">
                                    <div class="bank_ctirview" style="width: 0.555556rem; height: 0.555556rem;"><img style="display:block; width: 0.555556rem; height: 0.555556rem;" src="../../assets/img/tongxunlu.webp" alt=""></div>
                                </div>
                            </div>
                        </div>

                        <div class="bank_ctitems" @click="onCheckitem('two_mobile')">
                            <div class="bank_ctitem" :class="isCheck == 'two_mobile' ? 'bank_ctitem_active' : ''">
                                <van-field
                                        v-model="contacts_no2"
                                        label=""
                                        type="number"
                                        placeholder="Modificar el nombre del contacto"
                                        :clearable="isTrue"
                                        :maxlength="maxLenno"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="bank_conttop">
                        <div class="applyFormtitle">
                            <span></span> Contacto 3
                        </div>
                        <div class="bank_ctitems" @click="onCheckitem('thr')">
                            <div class="bank_ctitem" :class="isCheck == 'thr' ? 'bank_ctitem_active' : ''">
                                <div class="bank_ctileft">
                                    <template v-if="bankthrval == null">
                                        Elija el parentesco del contacto
                                    </template>
                                    <template v-else>
                                        {{bankthrval.name}}
                                    </template>
                                </div>
                                <div class="bank_ctiright">
                                    <div class="bank_ctirview"><img src="../../assets/img/comf_rparrow.png" alt=""></div>
                                </div>
                            </div>
                        </div>


                        <div class="bank_ctitems" @click="onCheckitem('thr_name')">
                            <div class="bank_ctitem" :class="isCheck == 'thr_name' ? 'bank_ctitem_active' : ''">
                                <div class="bank_ctileft" style="height: auto; padding-left: 0;">
                                    <van-field
                                            v-model="contacts_no3_name"
                                            label=""
                                            type="text"
                                            placeholder="Elija el contacto"
                                            :clearable="isTrue"
                                            :maxlength="maxLen"
                                    />
                                </div>
                                <div class="bank_ctiright" style="height: 0.555556rem; padding-right: 0.277778rem;">
                                    <div class="bank_ctirview" style="width: 0.555556rem; height: 0.555556rem;"><img style="display:block; width: 0.555556rem; height: 0.555556rem;" src="../../assets/img/tongxunlu.webp" alt=""></div>
                                </div>
                            </div>
                        </div>

                        <div class="bank_ctitems" @click="onCheckitem('thr_mobile')">
                            <div class="bank_ctitem" :class="isCheck == 'thr_mobile' ? 'bank_ctitem_active' : ''">
                                <van-field
                                        v-model="contacts_no3"
                                        label=""
                                        type="number"
                                        placeholder="Modificar el nombre del contacto"
                                        :clearable="isTrue"
                                        :maxlength="maxLenno"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="bank_contmiddle">
                        <div class="bank_contmleft">
                            <div class="bank_contmlview">
                                <img src="../../assets/img/apply_useicon.png" />
                            </div>
                        </div>
                        <div class="bank_contmright">
                            <p>
                                Superapoyomax mantiene su información personal privada y segura durante todo el proceso.
                            </p>
                        </div>
                    </div>

                    <div class="bank_contdown" style="padding-bottom: 30px;">
                        <van-button round color="#19A95C" block style="height: 1.111111rem;" @click.stop="onConfirm">
                            <span style="font-weight: 500;">Enviar</span>
                        </van-button>
                    </div>

                </div>
            </div>


            <van-action-sheet
                    v-model="bankoneShow"
                    :actions="actionsOne"
                    cancel-text="Cancelar"
                    description="Parentesco del contacto"
                    close-on-click-action
                    @select="onSelectOne"
            >
            </van-action-sheet>

            <van-action-sheet
                    v-model="banktwoShow"
                    :actions="actionsOne"
                    cancel-text="Cancelar"
                    description="Parentesco del contacto"
                    close-on-click-action
                    @select="onSelectTwo"
            >
            </van-action-sheet>

            <van-action-sheet
                    v-model="bankthrShow"
                    :actions="actionsOne"
                    cancel-text="Cancelar"
                    description="Parentesco del contacto"
                    close-on-click-action
                    @select="onSelectThr"
            >
            </van-action-sheet>


        </div>
    </div>
</template>

<script>

    import axios from 'axios'
    import { getTimezoneName, getUserIp } from '@/utils/commonParams';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import { getAccessToken } from '@/utils/auth';

    import { updateApplyContact } from '@/api/apply';
    import { getLoanInfo } from '@/api/loan';

    import { Toast } from 'vant';
    import $ from 'jquery';

    export default{
        data() {
            return {
                activeNav: 'living',
                isCheck: '1',
                isTrue: true,
                bankoneShow: false,
                bankoneval: null,
                actionsOne: [
                    { name: 'Esposo/a', id: '1', },
                    { name: 'Padres', id: '2', },
                    { name: 'Hermanos', id: '3', },
                    { name: 'Hijos', id: '4', },
                    { name: 'Amigos', id: '5', },
                ],
                contacts_no1_name: null,
                contacts_no1: null,
                banktwoShow: false,
                banktwoval: null,
                contacts_no2_name: null,
                contacts_no2: null,
                bankthrShow: false,
                bankthrval: null,
                contacts_no3_name: null,
                contacts_no3: null,
                bankmessage: null,
                bankIndexArr: [],
                bank_list: [],
                maxLen: 99,
                maxLenno: 11,
            }
        },
        mounted() {

        },
        methods: {
            onClickLeft() {
                this.$router.back();
            },
            onClickRight() {

            },
            onSelectOne(item) {
                console.log(item)
                this.bankoneval = item;
            },
            onSelectTwo(item){
                this.banktwoval = item;
            },
            onSelectThr(item){
                this.bankthrval = item;
            },
            onCheckitem(type){
                console.log(type)
                this.isCheck = type;
                if(type == 'one'){
                    this.bankoneShow = true;
                    this.banktwoShow = false;
                    this.bankthrShow = false;
                } else if(type == 'two'){
                    this.bankoneShow = false;
                    this.banktwoShow = true;
                    this.bankthrShow = false;
                } else if(type == 'thr'){
                    this.bankoneShow = false;
                    this.banktwoShow = false;
                    this.bankthrShow = true;
                }
            },
            onBarChange(index) {
                setTimeout(() => {
                    $('.van-index-anchor').css({
                        left: 0,
                        width: '90vw'
                    })
                }, 50);
            },
            onSelectBank(item){
                console.log(item)
                this.banktwoShow = false;
                this.banktwoval = item;
            },
            pySegSort(array) {
                let map = {};
                let indexArr = [];
                let newArr = [];
                for(let i = 0; i < 26; i++){
                    const key = String.fromCharCode(65 + i) //A-Z赋给key当作键
                    map[key] = {
                        title: key,
                        items: []
                    };
                    array.map((v,k)=>{      //遍历数组
                        console.log(v)
                        let firstIndex = v.bank_name.charAt(0).toUpperCase();//首字母
                        if(firstIndex.toUpperCase() == String.fromCharCode(65+i)){//统一转成大写进行逐个判断
                            map[key].items.push(v)//push进相对应的数组里头
                        }
                    })
                    // //如果当前的数组里头为空，则跳过。
                    if(map[key].items === undefined || map[key].items.length == 0){
                        continue;
                    }else{
                        indexArr.push(key)
                        newArr.push(map[key])//将分类好的每个对象 合并在一个数组里面
                    }
                }

                this.bankIndexArr = indexArr;

                loadingHide()

                return newArr;

            },
            async getCommomParams(data) {

                let postData = {
                    zzm_yya_hqb: getAccessToken(),
                    aaa_off_csl: '111',
                    ...data,
                };

                let time_zone = getTimezoneName();
                console.log(time_zone);
                let ip = await getUserIp()
                console.log(ip)

                let headerParams = {
                    'ad-justad-id': localStorage.getItem("adjust_id"),
                    'ad-justad-j': '',
                    'ad-justad-idfv': '',
                };

                loadingShow();
                updateApplyContact(postData, {
                    'bwd-irh-lnf': time_zone,
                    'xfo-plp-van': ip,
                    ...headerParams
                }).then(res => {
                    console.log(res)
                    if (res.ci == 200) {
                        let useData = res.da;
                        console.log(JSON.parse(useData))
                        if (useData) {
                            let useDataJSON = JSON.parse(useData);
                            let { bqr_rle_jto } = useDataJSON;
                            // 1001 工作信息
                            // 1002 联系人信息
                            // 1004 个人信息
                            // 1005 身份信息
                            // 1006 活体认证
                            // 1010 绑定银行卡
                            if(bqr_rle_jto == 8001){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applywork'
                                })
                            } else if(bqr_rle_jto == 8002){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applycontacts'
                                })
                            } else if(bqr_rle_jto == 8004){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applyperson'
                                })
                            } else if(bqr_rle_jto == 8005){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applyidcard'
                                })
                            } else if(bqr_rle_jto == 8006){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/livingverify'
                                })
                            } else if(bqr_rle_jto == 7106){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/livingverify'
                                })
                            } else if(bqr_rle_jto == 8010){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applybank'
                                })
                            } else if(bqr_rle_jto == 7101){
                                loadingHide()
                                this.gotoStatus()
                                // this.$router.replace({
                                //     path: '/loanpage/applyhome'
                                // })
                            } else if(bqr_rle_jto == 7102){
                                loadingHide()
                                this.gotoStatus()
                                // this.$router.replace({
                                //     path: '/loanpage/applyhome'
                                // })
                            } else if(bqr_rle_jto == 7105){
                                loadingHide()
                                this.gotoStatus()
                                // this.$router.replace({
                                //     path: '/loanpage/applyhome'
                                // })
                            } else if(bqr_rle_jto == 8110){
                                loadingHide()
                                this.gotoStatus()
                                // this.$router.replace({
                                //     path: '/loanpage/applyhome'
                                // })
                            }
                        }
                    } else {
                        loadingHide()
                        Toast(res.ms);
                    }
                }, error => {
                    loadingHide()
                })
            },
            async gotoStatus() {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    getLoanInfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        this.isInfoLoading = false;
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                let {vkt_fnd_yzo, ojq_dzg_oxq } = useDataJSON;
                                //order_status, reapply_time, server_time current_is_reloan,
                                let { omi_fje_qly, huw_kdq_nxo, xhi_cur_ovl } = vkt_fnd_yzo;

                                console.log(omi_fje_qly);
                                console.log(huw_kdq_nxo);
                                console.log(ojq_dzg_oxq);
                                console.log(xhi_cur_ovl);

                                this.orderStatusNor = omi_fje_qly;
                                this.getStatus(omi_fje_qly, huw_kdq_nxo,  ojq_dzg_oxq, xhi_cur_ovl, _this);

                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                        this.isInfoLoading = false;
                    });
                } else { //未登录
                    console.log('未登录1111')
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })

                }
            },
            getStatus: (value, reapply_time, server_time, current_is_reloan, _this) => {
                switch (value) {
                    case 0:
                    case 10:
                    case 15:
                    case 17:
                    case 21:
                        console.log('0没有申请过,10失效,15展期结清,17展期失效,21等待签约');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.replace({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.replace({
                                path: '/loanpage/applyhome'
                            });
                        }
                        break;
                    case 1:
                    case 2:
                    case 4:
                    case 13:
                    case 18:
                    case 19:
                    case 20:
                        console.log('//1提交申请,2提交审核,4等待人工审核,13等待第三方黑名单验证,18等待自动外呼,19等待人脸对比,20人工审核质检中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 1;
                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 3:
                        console.log('//审核拒绝');
                        if (_this.canReloanByTime(reapply_time, server_time)) {
                            _this.orderStatus = 2;
                            /*if (_this.isReloan) {
                                if(current_is_reloan != undefined){
                                    if(current_is_reloan == 1){
                                        _this.isReloan = 1;
                                    } else {
                                        _this.isReloan = 1;
                                    }
                                } else {
                                    _this.isReloan = 1;
                                }
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {

                            }*/

                            if(current_is_reloan != undefined){
                                if(current_is_reloan == 1){
                                    _this.isReloan = 1;
                                } else {
                                    _this.isReloan = null;
                                }
                            } else {
                                _this.isReloan = null;
                            }

                            if(_this.isReloan == 1){
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {
                                _this.$router.replace({
                                    path: '/loanpage/applyhome'
                                });
                            }

                        } else {
                            _this.orderStatus = 1;
                            _this.loanStatus = 2;

                            _this.$router.replace({
                                path: '/loanpage/loanstatus'
                            });
                        }
                        break;
                    case 5:
                    case 12:
                        console.log('//5等待放款，12正在放款中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 3;

                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 6:
                        console.log('//放款失败');
                        _this.orderStatus = 1;
                        _this.loanStatus = 4;

                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 7:
                    case 9:
                    case 11:
                    case 14:
                    case 16:
                        console.log('7等待还款，9逾期，11部分还款，14等待展期，16展期申请中');
                        _this.orderStatus = 3;

                        _this.$router.replace({
                            path: '/loanpage/repayment'
                        });
                        break;
                    case 8:
                        console.log('8已结清');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 1;
                            }
                        } else {
                            _this.isReloan = 1;
                        }
                        _this.$router.replace({
                            path: '/loanpage/reapeatloan'
                        });
                        break;
                    case 22:
                        console.log('22等待订单再次确认');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 0;
                            }
                        } else {
                            _this.isReloan = 0;
                        }

                        _this.$router.replace({
                            path: '/loanpage/firstloan'
                        });
                        break;
                    default:
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.replace({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.replace({
                                path: '/loanpage/applyhome'
                            });
                        }
                }
            },
            canReloanByTime(repTime, stime) {
                return repTime < stime;
            },
            onConfirm() {
                let bankoneval = this.bankoneval;
                let banktwoval = this.banktwoval;
                let bankthrval = this.bankthrval;

                let contacts_no1_name = this.contacts_no1_name;
                let contacts_no1 = this.contacts_no1;

                let contacts_no2_name = this.contacts_no2_name;
                let contacts_no2 = this.contacts_no2;

                let contacts_no3_name = this.contacts_no3_name;
                let contacts_no3 = this.contacts_no3;

                if(bankoneval && bankoneval.id){
                    if(contacts_no1_name){
                        if(contacts_no1){
                            let getmobile = contacts_no1;
                            let firstStr = getmobile.substr(0, 1);

                            if(firstStr == 1){ //1开始 11位

                                if(getmobile.length > 11){
                                    this.contacts_no1 = getmobile.substr(0, 11);
                                }

                            } else {//非1 10位
                                if(getmobile.length > 10){
                                    this.contacts_no1 = getmobile.substr(0, 10);
                                }
                            }

                            if(banktwoval && banktwoval.id){
                                if(contacts_no2_name){
                                    if(contacts_no2){
                                        let getmobile = contacts_no2;
                                        let firstStr = getmobile.substr(0, 1);

                                        if(firstStr == 1){ //1开始 11位

                                            if(getmobile.length > 11){
                                                this.contacts_no2 = getmobile.substr(0, 11);
                                            }

                                        } else {//非1 10位
                                            if(getmobile.length > 10){
                                                this.contacts_no2 = getmobile.substr(0, 10);
                                            }
                                        }

                                        let relationship3 = ''
                                        if(bankthrval && bankthrval.id){
                                            relationship3 = bankthrval.id;
                                        }

                                        /*let postData = {
                                            relationship1: bankoneval.id, //ait_ifo_zkf
                                            contact1_name: contacts_no1_name, //njr_soy_inm
                                            contact1_name_before: contacts_no1_name, //iyk_lal_iyo
                                            contact1: this.contacts_no1, //bsh_gcm_oxs
                                            relationship2: banktwoval.id, //ppj_tdl_fkl
                                            contact2_name: contacts_no2_name, //oqn_yie_hgp
                                            contact2_name_before: contacts_no2_name, //djp_wvk_yie
                                            contact2: this.contacts_no2, //ehu_pty_dwe
                                            relationship3, //klm_tcx_jwz
                                            contact3_name: contacts_no3_name, //pzh_cim_rbv
                                            contact3_name_before: contacts_no3_name, //rxl_the_umn
                                            contact3: contacts_no3, //obm_moa_aym
                                            czl_xat_evt,
                                            ucf_cmn_yee,
                                            jmc_lzo_cda,
                                        };*/

                                        let data = {
                                            ait_ifo_zkf: bankoneval.id,
                                            njr_soy_inm: contacts_no1_name,
                                            iyk_lal_iyo: contacts_no1_name,
                                            bsh_gcm_oxs: this.contacts_no1,
                                            ppj_tdl_fkl: banktwoval.id,
                                            oqn_yie_hgp: contacts_no2_name,
                                            djp_wvk_yie: contacts_no2_name,
                                            ehu_pty_dwe: this.contacts_no2,
                                            klm_tcx_jwz: relationship3,
                                            pzh_cim_rbv: contacts_no3_name,
                                            rxl_the_umn: contacts_no3_name,
                                            obm_moa_aym: contacts_no3,
                                            czl_xat_evt: '',
                                            ucf_cmn_yee: '',
                                            jmc_lzo_cda: '',
                                        };

                                        this.getCommomParams(data);
                                    }
                                } else {
                                    Toast('Introduzca el nombre del contacto')
                                }
                            } else {
                                Toast('Por favor, elija el parentesco del contacto')
                            }

                        } else {
                            Toast('Por favor ingrese el número de teléfono móvil')
                        }
                    } else {
                        Toast('Introduzca el nombre del contacto')
                    }

                } else {
                    Toast('Por favor, elija el parentesco del contacto')
                }

            },
        }
    }
</script>

<style less scoped>
    .apply_banner{
        width: 100%;
        height: 1.45rem;
        box-sizing: border-box;
        padding: 0.25rem 0.277778rem 0 0.277778rem;
        position: relative;
    }
    .apply_head{
        width: 100%;
        height: 0.75rem;
        position: relative;
    }
    .apply_hview{
        width: 8.944444rem;
        height: 0.555556rem;
        position: absolute;
        left: 0.56rem;
        top: -0.611111rem;
    }
    .apply_hview img{
        display: block;
        width: 8.944444rem;
        height: 0.555556rem;
    }
    .apply_topview{
        width: 100%;
        height: 2.055556rem;
        box-sizing: border-box;
        padding: 0 0.555556rem;
    }
    .apply_top{
        width: 100%;
        height: 1.555556rem;
        box-sizing: border-box;
        padding: 0 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #DDF2E7;
        border-radius: 0.111111rem;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 0.5rem;
    }
    .apply_formview{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0 0.555556rem;
    }
    .bank_conttop{
        width: 100%;
        height: auto;
    }
    .bank_ctitems{
        width: 100%;
        height: 1.472222rem;
    }
    .bank_ctitem{
        width: 100%;
        height: 1.111111rem;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 0.083333rem;
        border: 1px solid #DEE0E6;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .bank_ctitem_active{
        border: 1px solid #00CA88;
    }
    .bank_ctileft{
        width: auto;
        height: 14px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-left: 0.444444rem;
        font-size: 13px;
        font-weight: 500;
        color: #1A1A1A;
    }
    .bank_ctiright{
        width: auto;
        height: 8px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-right: 0.416667rem;
    }
    .bank_ctirview{
        width: 13px;
        height: 8px;
    }
    .bank_ctirview img{
        display: block;
        width: 13px;
        height: 8px;
    }
    .bank_ctitem_active .bank_ctileft{
        color: #1A1A1A;
    }
    .bank_ctitem .bank_code{
        display: block;
        width: 90%;
        height: 0.8rem;
        outline: none;
        border: none;
        background: #ffffff;
        border-radius: 0.333333rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-left: 0.444444rem;
        font-size: 13px;
        font-weight: 500;
        color: #1A1A1A;
    }
    .bank_ctitem_active .bank_code{
        color: #1A1A1A;
    }
    .bank_contmiddle{
        width: 100%;
        height: 1.611111rem;
        display: flex;
        justify-content: flex-start;
    }
    .bank_contmleft{
        width: 0.666667rem;
        height: 0.444444rem;
    }
    .bank_contmlview{
        width: 0.394444rem;
        height: 0.444444rem;
        margin-top: 2px;
    }
    .bank_contmlview img{
        display: block;
        width: 0.394444rem;
        height: 0.444444rem;
    }
    .bank_contmright{
        width: 7.888889rem;
        height: 1.0rem;
        display: flex;
        align-items: center;
    }
    .bank_contmright p{
        font-size: 0.333333rem;
        font-weight: 500;
        color: #999999;
    }
    .bank_contdown{
        width: 7.722222rem;
        height: 1.111111rem;
        margin: 0 auto;
    }
    .zhou_wrap{
        width: 90vw;
        height: 100vh;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .applyFormtitle{
        width: 100%;
        height: 0.777778rem;
        font-size: 0.388889rem;
        font-weight: 600;
        color: #333333;
        line-height: 0.555556rem;
    }
    .applyFormtitle span{
        color: #FB4840;
    }
</style>

<style less>
    #applybank .van-action-sheet__description{
        background: #19A95C;
        color: #ffffff;
        font-size: 16px;
    }
    #applybank .van-action-sheet__cancel{
        color: #FB4840;
    }
    #applybank .van-action-sheet__item .van-action-sheet__name{
        color: #19A95C;
    }
    #applybank .van-cell{
        padding: 4px 0.444444rem 4px 0.416667rem;
    }
    #applybank .van-index-bar__index{
        padding: 4px 8px 4px 16px;
    }
    #applybank .van-dialog{
        width: 76.39vw;
        border-radius: 0.277778rem;
    }
    #applybank .van-dialog__confirm, .van-dialog__confirm:active{
        background: #19A95C;
    }
</style>